// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox_tournament_Form{
    display: flex;
    align-items: flex-end;
    margin: var(--space-half) 0;
}

.checkbox_tournament_Form_input{
    width: var(--space);
    height: var(--space);
    margin-right: 9px;
}

.baloa-username.checkbox_tournament_Form_label_question{
    font-weight: var(--font-medium);
    color: var(--basic-gray-color);
}

.checkbox_tournament_Form_label{
    font-family: var(--secondary-font);
    font-weight: var(--font-regular);
    line-height: calc( var(--space) + var(--space-quarter) );
    letter-spacing: 0.0025em;
    letter-spacing: 0.005em;
    color: var(--basic-gray-color);
    font-size: 14px !important;
}

input[type="checkbox"]:before {
	content: "";
	width: 18px;
	height: 18px;
	float: left;
	/* margin: 0.5em 0.5em 0 0; */
	border: 1px solid #ccc;
    border-radius: 2px;
	background:var(--white-color);
}

input[type="checkbox"]:checked:before {
	border-color: var(--white-color);
    background: var(--new-green-color);
    border: 1px solid #ccc;
}

input[type="checkbox"]:checked:after {
    content: "";
    width: 11px;
    height: 6px;
    border: 2px solid var(--white-color);
    float: left;
    margin-left: 3px;
    border-right: 0;
    border-top: 0;
    margin-top: -13px;
    transform: rotate(-55deg);
}

.checkbox_tournament{
    padding-bottom: var(--space-and-half);
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/dynamic-fields-tournament-form/check-tournament-form/CheckTournamentFormComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,wDAAwD;IACxD,wBAAwB;IACxB,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;CACC,WAAW;CACX,WAAW;CACX,YAAY;CACZ,WAAW;CACX,6BAA6B;CAC7B,sBAAsB;IACnB,kBAAkB;CACrB,6BAA6B;AAC9B;;AAEA;CACC,gCAAgC;IAC7B,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":[".checkbox_tournament_Form{\n    display: flex;\n    align-items: flex-end;\n    margin: var(--space-half) 0;\n}\n\n.checkbox_tournament_Form_input{\n    width: var(--space);\n    height: var(--space);\n    margin-right: 9px;\n}\n\n.baloa-username.checkbox_tournament_Form_label_question{\n    font-weight: var(--font-medium);\n    color: var(--basic-gray-color);\n}\n\n.checkbox_tournament_Form_label{\n    font-family: var(--secondary-font);\n    font-weight: var(--font-regular);\n    line-height: calc( var(--space) + var(--space-quarter) );\n    letter-spacing: 0.0025em;\n    letter-spacing: 0.005em;\n    color: var(--basic-gray-color);\n    font-size: 14px !important;\n}\n\ninput[type=\"checkbox\"]:before {\n\tcontent: \"\";\n\twidth: 18px;\n\theight: 18px;\n\tfloat: left;\n\t/* margin: 0.5em 0.5em 0 0; */\n\tborder: 1px solid #ccc;\n    border-radius: 2px;\n\tbackground:var(--white-color);\n}\n\ninput[type=\"checkbox\"]:checked:before {\n\tborder-color: var(--white-color);\n    background: var(--new-green-color);\n    border: 1px solid #ccc;\n}\n\ninput[type=\"checkbox\"]:checked:after {\n    content: \"\";\n    width: 11px;\n    height: 6px;\n    border: 2px solid var(--white-color);\n    float: left;\n    margin-left: 3px;\n    border-right: 0;\n    border-top: 0;\n    margin-top: -13px;\n    transform: rotate(-55deg);\n}\n\n.checkbox_tournament{\n    padding-bottom: var(--space-and-half);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
